import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Package, Percent, Gift, HandCoins, BarChart3 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { PlansTab } from '@/components/admin/commerce/PlansTab';
import { PromotionsTab } from '@/components/admin/commerce/PromotionsTab';
import { LoyaltyTab } from '@/components/admin/commerce/LoyaltyTab';
import { GrantsTab } from '@/components/admin/commerce/GrantsTab';
import { SalesTab } from '@/components/admin/commerce/SalesTab';

const TABS = [
  { key: 'plans', icon: Package, Comp: PlansTab },
  { key: 'promotions', icon: Percent, Comp: PromotionsTab },
  { key: 'loyalty', icon: Gift, Comp: LoyaltyTab },
  { key: 'grants', icon: HandCoins, Comp: GrantsTab },
  { key: 'sales', icon: BarChart3, Comp: SalesTab },
];

export default function AdminCommerce() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const [tab, setTab] = useState(params.get('tab') || 'plans');

  useEffect(() => { if (user && user.role !== 'admin') navigate('/dashboard'); }, [user, navigate]);
  useEffect(() => { setParams({ tab }, { replace: true }); }, [tab, setParams]);

  if (user && user.role !== 'admin') return null;
  const Active = TABS.find((x) => x.key === tab)?.Comp || PlansTab;

  return (
    <div className="min-h-screen bg-gray-50 py-10" data-testid="admin-commerce-page">
      <div className="max-w-6xl mx-auto px-4">
        <p className="text-xs uppercase tracking-widest text-emerald-700 font-semibold mb-1">{t('adminCommerce.eyebrow')}</p>
        <h1 className="text-3xl font-bold text-slate-900 mb-2">{t('adminCommerce.title')}</h1>
        <p className="text-slate-600 mb-6 max-w-2xl">{t('adminCommerce.subtitle')}</p>

        <nav className="flex gap-1 border-b border-slate-200 mb-6 overflow-x-auto" aria-label={t('adminCommerce.title')}>
          {TABS.map(({ key, icon: Icon }) => (
            <button
              key={key}
              type="button"
              onClick={() => setTab(key)}
              className={`inline-flex items-center gap-2 px-4 h-11 text-sm font-medium border-b-2 -mb-px whitespace-nowrap transition-colors ${tab === key ? 'border-emerald-600 text-emerald-700' : 'border-transparent text-slate-500 hover:text-slate-800'}`}
              data-testid={`commerce-tab-${key}`}
            >
              <Icon className="h-4 w-4" />{t(`adminCommerce.tabs.${key}`)}
            </button>
          ))}
        </nav>

        <Active />
      </div>
    </div>
  );
}
